import * as React from 'react'
import { ComponentProps } from 'react'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  description?: string
  illustration?: ComponentProps<typeof Icon.Large>['icon']
  action?: {
    label: string
    onClick: () => void
  }
}

export const MissingInformation: React.FC<Props> = ({
  description,
  action,
  illustration = 'lightbulb',
}) => {
  return (
    <Box alignItems="center" gap="s16" width="full" paddingTop="s16" paddingBottom="s32">
      <Icon.Large icon={illustration} color="grey600" />
      <Box textAlign="center">
        <Text color="grey1000" size="300" weight="semibold">
          {i18n.t('performance_process.reviews.launch_information_title_missing')}
        </Text>
        <Text size="300">
          {description ||
            i18n.t('performance_process.reviews.launch_information_description_missing')}
        </Text>
      </Box>
      {action && (
        <Button onClick={action.onClick} type="secondary">
          {action.label}
        </Button>
      )}
    </Box>
  )
}
